'use strict'

module.exports = require('./utils/interpolate').interpolateArray(require('./hex/magma.json'))



//////////////////
// WEBPACK FOOTER
// ./~/scale-color-perceptual/magma.js
// module id = 850
// module chunks = 0